import { Options } from 'highcharts';

import { useUserLocale } from '@/i18n/hooks';
import { Unit } from '@/types/Unit';

import { getUnitNumberFormat } from '../utils/getUnitNumberFormat';
import { DonutChartData } from './types/DonutChartData';

export const useDonutChartOptions = (
  data: DonutChartData,
  size: number,
  unit: Unit,
  positionLegendBottom: boolean,
): Options => {
  const locale = useUserLocale();

  return {
    chart: {
      type: 'pie',
      height: size + 200,
      numberFormatter(value) {
        return getUnitNumberFormat(value, unit, locale);
      },
    },
    plotOptions: {
      pie: {
        size,
        innerSize: '70%',
        showInLegend: true,
        borderRadius: 0,
        borderWidth: 2,
        borderColor: 'white',
        dataLabels: {
          formatter() {
            return `
            <span style="color: var(--p-color-text-primary);">${this.point.name}
            <br/><b>${getUnitNumberFormat(this.y!, unit, locale)}</b>
            </span>`;
          },
          connectorWidth: 0,
          style: {
            fontSize: '14px',
            fontWeight: '400',
          },
        },
        tooltip: {
          pointFormatter() {
            return `<b>${getUnitNumberFormat(this.y!, unit, locale)}</b>`;
          },
        },
      },
    },
    legend: {
      itemStyle: {
        fontWeight: '400',
        fontSize: '14px',
        color: 'var(--p-color-text-primary)',
      },
      itemDistance: 24,
      itemMarginTop: 8,
      symbolRadius: 0,
      symbolHeight: 12,
      symbolWidth: 12,
      ...(!positionLegendBottom && {
        align: 'right',
        verticalAlign: 'middle',
        layout: 'vertical',
        width: 250,
      }),
    },
    colors: [
      'var(--p-color-categorical-1)',
      'var(--p-color-categorical-2)',
      'var(--p-color-categorical-3)',
      'var(--p-color-categorical-4)',
      'var(--p-color-categorical-5)',
      'var(--p-color-categorical-6)',
      'var(--p-color-categorical-7)',
      'var(--p-color-categorical-8)',
      'var(--p-color-categorical-9)',
      'var(--p-color-categorical-10)',
      'var(--p-color-categorical-11)',
      'var(--p-color-categorical-12)',
    ],
    series: [
      {
        type: 'pie',
        data,
      },
    ],
    credits: {
      enabled: false,
    },

    title: undefined,
  };
};
